// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2zWmX","item":"PaymentsMobile_item__2Lg3a","label":"PaymentsMobile_label__2zS25","amount":"PaymentsMobile_amount__1VCZw"};